<template>
  <div class="question mt-6" :class="{ isGroup: isQuestionGroup }">
    <template v-if="!isQuestionGroup">
      <div class="stem">
        <div></div>
        <div flex>
          <slot></slot>
          <div flex>
            <div
              class="questionSeq"
              v-if="seq && $slots.childrenSeq"
              style="margin-right: 16px"
            >
              <slot name="childrenSeq"></slot>
            </div>
            <div flex>
              <div
                class="questionSeq"
                v-if="seq && !$slots.seq && !$slots.childrenSeq"
                style="margin-right: 16px"
              >
                {{ isBigCloze ? "选项" : "" }}{{ seq }}.
              </div>
              <div
                class="questionSeq"
                v-if="seq && $slots.seq"
                style="margin-right: 16px"
              >
                <slot name="seq"></slot>
              </div>
              <div v-if="$slots.score" style="display: inline-block">
                <slot name="score"></slot>
              </div>
              <div
                v-if="showType"
                class="questionType"
                style="margin-right: 10px"
              >
                【{{ dict.label.question_type[questionInfo.questionType] }}】
              </div>

              <div
                class="questionScore"
                v-if="
                  questionInfo.questionScore && questionInfo.questionScore >= 0
                "
                style="margin-right: 10px"
              >
                ({{ questionInfo.questionScore }}分)
              </div>
            </div>
          </div>
          <!--        <div  class="stem-box" flex style="line-height: 28px; flex: 1; min-width: 0" :style="{lineHeight: $slots.score ? '36px' : '28px', 'align-items': $slots.score ? 'center' : 'flex-start', display: $slots.default ? 'inline' : 'block'}">-->

          <!--          </div>-->

          <!--          <div class="questionScore" v-if="questionInfo.questionScore >= 0" style="margin-right: 10px">-->
          <!--            ({{ questionInfo.questionScore }}分)-->
          <!--          </div>-->
        </div>

        <template v-if="!parentIsBigCloze">
          <bc-view-common
            style="flex: 1; min-width: 0"
            :content="questionInfo.stem.content"
            :border="false"
            v-if="!$slots.score"
            :fileInfo="questionInfo.stem.fileInfo"
          >
          </bc-view-common>
        </template>

        <template v-else>
          <div
            style="display: inline"
            v-if="questionInfo.questionScore && questionInfo.questionScore >= 0"
          >
            ({{ questionInfo.questionScore }}分)
          </div>
        </template>

        <template v-if="!parentIsBigCloze">
          <bc-view-common
            style="flex: 1; min-width: 0"
            :content="questionInfo.stem.content"
            :border="false"
            v-if="$slots.score"
            class="mt-4"
            :fileInfo="questionInfo.stem.fileInfo"
          ></bc-view-common>
        </template>
      </div>

      <div class="options mt-4" v-if="showOptions">
        <div flex="1">
          <!--        <div class="question-label">选项：</div>-->
          <bc-view-option
            style="flex: 1; min-width: 0"
            :option="questionInfo.questionOption"
          ></bc-view-option>
        </div>
      </div>

      <template v-if="showSort">
        <div class="mt-6">
          <div flex="1">
            <!--                <div class="question-label">正确答案：</div>-->
            <bc-sort-question-view
              style="flex: 1; min-width: 0"
              :option="questionInfo.questionOption"
            ></bc-sort-question-view>
          </div>
        </div>

        <div class="mt-6">
          <div flex>
            <div class="question-label">正确答案：</div>
            <div style="color: #0070c1; min-width: 0; flex: 1">
              {{ standardAnswer }}
            </div>
          </div>
        </div>
      </template>

      <div class="mt-4" v-else-if="showRichTextAnswer">
        <div flex="1">
          <div class="question-label">正确答案：</div>
          <div style="flex: 1; min-width: 0">
            <bc-view-common
              :content="questionInfo.standardAnswer.content"
              :border="false"
              style="flex: 1; min-width: 0"
              :fileInfo="questionInfo.standardAnswer.fileInfo"
            ></bc-view-common>
          </div>
        </div>
      </div>

      <div v-else-if="isHideAnswer"></div>

      <template v-else-if="isLineQuestion">
        <div class="mt-6">
          <div flex="1">
            <!--                <div class="question-label">正确答案：</div>-->
            <div style="flex: 1; min-width: 0">
              <bc-line-question-view
                style="flex: 1; min-width: 0"
                :options="questionInfo.questionOption || []"
              ></bc-line-question-view>
            </div>
          </div>
        </div>

        <div>
          <div style="margin: 10px 0" class="question-label">正确答案：</div>
          <div>
            <bc-line-question-view-line
              style="flex: 1; min-width: 0"
              :options="questionInfo.questionOption || []"
            ></bc-line-question-view-line>
          </div>
        </div>
      </template>

      <template v-else-if="isCloze">
        <div class="mt-4">
          <div flex="1">
            <div class="question-label">正确答案：</div>
            <bc-view-option
              style="flex: 1; min-width: 0"
              :option="questionInfo.standardAnswer"
            ></bc-view-option>
          </div>
        </div>

        <div class="mt-4" v-if="questionInfo.answerSequence">
          <div flex>
            <div class="question-label">作答顺序：</div>

            <div>{{ questionInfo.answerSequence }}</div>
          </div>
        </div>
      </template>

      <div class="mt-4" v-else>
        <div flex>
          <div class="question-label">正确答案：</div>
          <div style="color: #0070c1; min-width: 0; flex: 1; line-height: 28px">
            {{ standardAnswer }}
          </div>
        </div>
      </div>

      <div
        class="mt-4"
        flex="cross:center"
        style="line-height: 28px"
        v-if="showStatistics"
      >
        <div style="margin-right: 50px">
          难度：{{ dict.label.difficulty[questionInfo.difficulty] }}
        </div>

        <div
          flex=""
          style="margin-right: 62px"
          v-if="
            questionInfo.knowledgePoints && questionInfo.knowledgePoints.length
          "
        >
          <div>知识点：</div>
          <div>
            <el-tag
              effect="plain"
              v-for="item in questionInfo.knowledgePoints"
              :key="item.id"
              >{{ item.kpName }}</el-tag
            >
          </div>
        </div>

        <div flex="cross:center">
          <div style="color: #0070c1">
            共答过{{
              questionInfo.astatistics
                ? questionInfo.astatistics.totalAnswersNum
                : 0
            }}次， 答对{{
              questionInfo.astatistics
                ? questionInfo.astatistics.correctAnswersNum
                : 0
            }}次，答错{{
              questionInfo.astatistics
                ? questionInfo.astatistics.wrongAnswersNum
                : 0
            }}次
          </div>
        </div>
      </div>
      <div class="question-label" style="line-height: 40px">答案解析：</div>
      <div flex v-if="showAnalysis">
        <!-- <div class="mt-4" flex v-if="showAnalysis"> -->
        <!-- <div class="question-label" style="line-height: 40px">答案解析：</div> -->
        <div
          style="min-width: 0; flex: 1"
          class="stem"
          :class="{ 'analysis-content': questionInfo.analysis.content }"
        >
          <bc-view-common
            v-if="
              questionInfo.analysis.content ||
              (questionInfo.analysis.fileInfo &&
                questionInfo.analysis.fileInfo.fileUrl)
            "
            :border="false"
            :content="questionInfo.analysis.content"
            :fileInfo="questionInfo.analysis.fileInfo"
          ></bc-view-common>

          <div v-else class="analysis-content">暂无解析</div>
        </div>
      </div>
    </template>

    <template v-else>
      <slot v-if="!isBigCloze"></slot>

      <div flex style="flex: 1; min-width: 0" class="questionGroupContent">
        <slot v-if="isBigCloze"></slot>

        <div class="questionType" v-if="showType">
          【{{ dict.label.question_type[questionInfo.questionType] }}】
        </div>

        <!--        <div class="questionScore" v-if="questionInfo.questionScore >= 0" style="margin-right: 10px">-->
        <!--          ({{ questionInfo.questionScore }}分)-->
        <!--        </div>-->
        <div
          class="questionSeq"
          v-if="seq && !$slots.seq"
          style="margin-right: 16px; line-height: 28px"
        >
          {{ seq }}.
        </div>
        <div
          class="questionSeq"
          v-if="seq && $slots.seq"
          style="margin-right: 16px; line-height: 28px"
        >
          <slot name="seq"></slot>
        </div>
        <div v-if="$slots.score" style="display: inline-block">
          <slot name="score"></slot>
        </div>
        <div class="group-content">
          <bc-view-common
            style="flex: 1; min-width: 0"
            :content="questionInfo.stem.content"
            :border="false"
            :fileInfo="questionInfo.stem.fileInfo"
          >
            <div
              class="questionScore"
              v-if="
                questionInfo.questionScore && questionInfo.questionScore >= 0
              "
              style="margin-right: 10px"
            >
              ({{ questionInfo.questionScore }}分)
            </div>
          </bc-view-common>

          <bc-question-detail-view
            v-if="questionInfo.groupQuestion"
            :dict="dict"
            :seq="index + 1"
            v-for="(item, index) in questionInfo.groupQuestion"
            :key="item.id"
            :question="item"
            :parentIsBigCloze="isBigCloze"
            :show-type="!isBigCloze"
            :style="{ paddingLeft: isBigCloze ? '0' : '20px' }"
          >
            <span slot="childrenSeq"
              >{{ isBigCloze ? "选项" : "小题" }}{{ index + 1 }}.</span
            >
            <div slot="score" v-if="isEditGroup" flex="cross:center">
              <div style="margin-right: 10px">分值</div>
              <el-input-number :min="0" :controls="false"></el-input-number>
            </div>
          </bc-question-detail-view>
          <bc-question-detail-view
            v-if="questionInfo.questionList"
            :dict="dict"
            :seq="index + 1"
            v-for="(item, index) in questionInfo.questionList"
            :key="item.id"
            :question="item"
            :parentIsBigCloze="isBigCloze"
            :show-type="!isBigCloze"
            :style="{ paddingLeft: isBigCloze ? '0' : '20px' }"
          >
            <span slot="childrenSeq"
              >{{ isBigCloze ? "选项" : "小题" }}{{ index + 1 }}.</span
            >

            <div slot="score" v-if="isEditGroup" style="display: inline-block">
              <div flex="cross:center">
                <div style="margin-right: 10px">分值</div>
                <el-input-number
                  @change="changeGroupChildrenScore($event, index)"
                  :max="questionMaxScore"
                  v-model="item.questionScore"
                  :min="0"
                  :controls="false"
                ></el-input-number>
              </div>
            </div>
          </bc-question-detail-view>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  isBigCloze,
  isCloze,
  isHideAnswer,
  isLineQuestion,
  isQuestionGroup,
  showAnalysis,
  showJudgeAnswer,
  showOptions,
  showRichTextAnswer,
  showSort,
} from "@/utils/questionType";
import XEUtils from "xe-utils";

export default {
  name: "bc-question-detail-view",

  props: {
    question: {
      type: Object,
      default: () => {},
    },
    dict: {
      type: Object,
      default: () => {},
    },
    seq: {
      type: Number,
      default: 0,
    },
    showType: {
      type: Boolean,
      default: true,
    },
    isEditGroup: {
      default: false,
      type: Boolean,
    },
    questionMaxScore: {
      default: 100,
      type: Number,
    },
    showStatistics: {
      default: true,
      type: Boolean,
    },
    parentIsBigCloze: {
      default: false,
      type: Boolean,
    },
  },

  watch: {
    question: {
      handler(val) {
        try {
          this.questionInfo = {
            ...val,
            stem: val.stem ? JSON.parse(val.stem) : {},
            analysis: val.analysis ? JSON.parse(val.analysis) : {},
            standardAnswer: val.standardAnswer
              ? JSON.parse(val.standardAnswer)
              : {},
            questionOption: val.questionOption
              ? JSON.parse(val.questionOption)
              : "[]",
          };
        } catch (err) {
          console.log(err);
        }
      },
      immediate: true,
      deep: true,
    },
  },

  computed: {
    showOptions() {
      return showOptions(this.questionInfo.questionType);
    },
    showJudgeAnswer() {
      return showJudgeAnswer(this.questionInfo.questionType);
    },
    showSort() {
      return showSort(this.questionInfo.questionType);
    },
    showRichTextAnswer() {
      return showRichTextAnswer(this.questionInfo.questionType);
    },
    showAnalysis() {
      return showAnalysis(this.questionInfo.questionType);
    },
    isHideAnswer() {
      return isHideAnswer(this.questionInfo.questionType);
    },
    isLineQuestion() {
      return isLineQuestion(this.questionInfo.questionType);
    },
    isCloze() {
      return isCloze(this.questionInfo.questionType);
    },
    isBigCloze() {
      return isBigCloze(this.questionInfo.questionType);
    },
    isQuestionGroup() {
      return isQuestionGroup(this.questionInfo.questionType);
    },
    standardAnswer() {
      try {
        let answerTitle = "";
        if (!this.showRichTextAnswer) {
          if (this.showOptions) {
            answerTitle = this.questionInfo.standardAnswer
              .map((i) => i.title)
              .join("、");
          } else if (this.showJudgeAnswer) {
            answerTitle = this.questionInfo.standardAnswer
              .map((i) => i)
              .join("、");
          } else if (this.showSort) {
            let questionOption = XEUtils.clone(
              this.questionInfo.questionOption,
              true
            );
            answerTitle = questionOption
              .sort((c, n) => c.index - n.index)
              .map((i) => i.title)
              .join("、");
          }
        }

        return answerTitle;
      } catch (e) {
        return "";
      }
    },
  },

  data() {
    return {
      questionInfo: {},
    };
  },
  methods: {
    changeGroupChildrenScore(val, questionIndex) {
      this.$emit("changeChildrenScore", {
        score: val,
        childrenIndex: questionIndex,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.group-content {
  flex: 1;
  min-width: 0;
}

.question.isGroup {
  //display: flex;
  //align-items: flex-start;
}
</style>
